import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { LoaderEvent } from "@lib/titan2/dist/loader/event/LoaderEvent";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import gsap from "gsap";
import * as PIXI from "pixi.js";
/**
* Game.ts
*/
export class Game extends AbstractGameView {
    create() {
        super.create();
        Logger.addObjectRef(this, "Game");
        const defaultTickerSpeed = PIXI.Ticker.shared.speed;
        const defaultGsapSpeed = gsap.globalTimeline.timeScale();
        window.setSpeed = x => {
            PIXI.Ticker.shared.speed = x * defaultTickerSpeed;
            gsap.globalTimeline.timeScale(x * defaultGsapSpeed);
        };
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(CommonGameEvent.INITIALISE, this.handleInitialise);
        this.registerGame(LoaderEvent.PRELOADER_COMPLETE, this.handleLoaderComplete);
        this.registerGame(LoaderEvent.COMPLETE, this.handleLoaderComplete);
    }
    handleInitialise() {
        this.addChild(this.factory.createMain(), this.factory.createTopBar(), this.factory.createNavigation());
        if (this.factory.hasInGameReplay()) {
            const history = this.factory.createGameHistory();
            if (history) {
                this.addChild(history);
            }
        }
        this.renderer.forceResize();
        this.renderer.hideMask();
    }
    handleLoaderComplete() {
        this.renderer.setBackgroundColour(this.factory.getBackgroundColour());
    }
}
//# sourceMappingURL=Game.js.map